var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-codeeditor",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "DsfTextProxy",
                _vm._b(
                  {
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  "DsfTextProxy",
                  _vm._self.$props,
                  false
                )
              ),
              _vm.value != ""
                ? _c("span", [_vm._v(_vm._s(_vm.append))])
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c(
                    "div",
                    { style: { height: _vm.unitSize(_vm.height) } },
                    [
                      !_vm.isRefresh
                        ? _c("monaco-editor", {
                            ref: "editor",
                            attrs: {
                              language: _vm.language,
                              code: _vm.value,
                              options: _vm.options,
                            },
                            on: {
                              codeChange: _vm.codeChangeHandler,
                              blur: _vm.codeBlurHandler,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "ds-form-readonly",
                      style: { height: _vm.unitSize(_vm.height) },
                    },
                    [
                      !_vm.isRefresh
                        ? _c("monaco-editor", {
                            ref: "editor",
                            attrs: {
                              language: _vm.language,
                              code: _vm.value,
                              options: _vm.options,
                            },
                            on: {
                              codeChange: _vm.codeChangeHandler,
                              blur: _vm.codeBlurHandler,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }